import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch the currently logged-in user with:
 * - Basic user info (id, name, email)
 * - WordPress roles
 * - WordPress capabilities (both existing WP/WooCommerce caps and business_* caps)
 * 
 * Note: If 'capabilities' field is not available in WPGraphQL, you may need to:
 * 1. Add a custom field resolver in WordPress
 * 2. Or fetch capabilities from user meta/roles
 * 3. Or use a WPGraphQL extension that exposes capabilities
 */
export const GET_CURRENT_USER_PERMISSIONS = gql`
  query GetCurrentUserPermissions {
    viewer {
      id
      databaseId
      name
      email
      roles {
        nodes {
          name
        }
      }
      capabilities
    }
  }
`;

/**
 * Alternative query if capabilities need to be fetched differently
 * Uncomment and modify if your WPGraphQL setup requires a different approach
 */
/*
export const GET_CURRENT_USER_PERMISSIONS_ALT = gql`
  query GetCurrentUserPermissions {
    viewer {
      id
      name
      email
      roles {
        nodes {
          name
          capabilities
        }
      }
    }
  }
`;
*/

export interface UserRole {
  name: string;
}

export interface UserPermissionsData {
  viewer: {
    id: string;
    databaseId?: number;
    name: string;
    email: string;
    roles: {
      nodes: UserRole[];
    };
    capabilities: string[];
  };
}
